module.exports = __webpack_public_path__ + "media/images/audit-d76da80ca787b0eb1a8a23e0ae398b2b.svg";